import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {Store} from '@ngrx/store';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';
import {getFromAppQueue} from '../../store/core.actions';
import {selectFromAppQueue, selectIsFromAppQueueLoading} from '../../store/core.selectors';

@Component({
  selector: 'app-from-app-queue-modal',
  templateUrl: './from-app-queue-modal.component.html',
  styleUrls: ['./from-app-queue-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FromAppQueueModalComponent {
  protected readonly icons = IconsEnum;
  protected readonly isLoading = toSignal(inject(Store).select(selectIsFromAppQueueLoading), {initialValue: true});
  protected readonly items = toSignal(inject(Store).select(selectFromAppQueue), {initialValue: []});
  private readonly modalController = inject(ModalControllerService);
  private readonly store = inject(Store);

  protected async onClose(): Promise<void> {
    await this.modalController.dismiss();
  }

  protected onRefresh(): void {
    this.store.dispatch(getFromAppQueue({}));
  }
}
